import EpgEvent from '../../../classes/epgEvent';
import Event from '@shared/classes/event';
import RegularEvent from '../../../classes/regularEvent';
import { store } from '../../../store/store';
import { updateEvents as updateEventsAction } from '../../../store/thunks/events.thunk';
import { useAppDispatch } from '../../../store/hooks';
import { useCallback, useEffect, useRef } from 'react';

function useUpdateEvents({
  asset,
  data: ogData,
  filter,
  changeDescription,
}: {
  asset?: Event;
  data: (EpgEvent | RegularEvent | undefined)[];
  filter: string;
  changeDescription?: () => void;
}) {
  const dispatch = useAppDispatch();
  const dataRef = useRef(ogData);

  // Actions

  const updateEvents = useCallback(() => {
    dispatch(updateEventsAction(true));
    if (!dataRef.current.length) return;
    const { events } = store.getState();
    const newData = dataRef.current.map((item) => {
      if (item && item.channel)
        return (
          events.currentEvents[item.channel.id] ||
          events.mockedEvents[item.channel.id]
        );
      return item;
    });
    if (changeDescription) changeDescription();
    dataRef.current = newData;
  }, [dispatch, changeDescription]);

  // Effect hooks

  useEffect(() => {
    dataRef.current = ogData;
    updateEvents();
  }, [ogData.length, filter]);

  // Effect hooks

  useEffect(() => {
    const end = asset?.date?.end;
    if (end == null) return;

    const runWhenPastEnd = () => {
      if (Date.now() > end) updateEvents();
    };

    runWhenPastEnd();
    if (Date.now() > end) return;

    const delay = Math.max(0, end - Date.now() + 1);
    const timerId = setTimeout(runWhenPastEnd, delay);
    return () => clearTimeout(timerId);
  }, [asset?.eventId, asset?.date?.end, updateEvents]);

  return dataRef.current as EpgEvent[];
}

export default useUpdateEvents;
